import Swal from 'sweetalert2';
import { api } from '../../domainConfig';
import axiosInstance from '../axiosInstance';
/* eslint no-shadow: ["error", { "allow": ["state"] }] */

const domain = api.vacationManagementDomain;
const domain2 = api.logisticStoreData;

const state = {
  status: false,
  canton: null,
  vacationRequests: [],
  hasVacation: false,
  remainingDays: null,
  ourBankHolidays: [],
  saturdayWork: {},
};

const getters = {
  getBankHolidays: (state) => {
    return state.ourBankHolidays
  },
  getCantons: (state) => {
    return state.canton;
  },
  getHasVacation: (state) => {
    return state.hasVacation;
  },
  getVacationRequests: (state) => {
    return state.vacationRequests;
  },
  getRemainingDays: (state) => {
    return state.remainingDays;
  },
  getActiveVacationRequests: (state) => {
    return state.vacationRequests.vacationRequestDtos.filter((vacation) => {
      return vacation.cancelled == false && new Date(vacation.endVacation) >= new Date();
    });
  },
  getInActiveVacationRequests: (state) => {
    return state.vacationRequests.vacationRequestDtos.filter((vacation) => {
      return vacation.cancelled == true || new Date(vacation.endVacation) <= new Date();
    });
  },
  getPastAndFutureVacations: (state) => {
    return state.vacationRequests.vacationRequestDtos.filter((vacation) => {
      return vacation.cancelled == false
    });
  },
  getSaturdayWork: (state) => {
    return state.saturdayWork
  },
};

const mutations = {
  SET_BANKHOLIDAYS(state, payload) {
    state.ourBankHolidays = payload;
  },
  SET_STATUS(state, payload) {
    state.status = payload;
  },
  SET_CANTON(state, latest) {
    state.canton = latest;
  },
  SET_VACATION_REQUESTS(state, latest) {
    state.vacationRequests = latest;
  },
  SET_ALREADY_REQUESTED_VACATION(state, latest) {
    state.hasVacation = latest;
  },
  SET_REMAINING_DAYS(state, latest) {
    state.remainingDays = latest;
  },
  SET_SATURDAY_WORK(state, latest) {
    state.saturdayWork = latest
  },
};

const actions = {
  async loadCountryStates({ commit }) {
    const requestId = 'loadCountryStates'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    const countryid = '9080b1da-4da4-4b25-5c93-08db31f6edb2';
    try {
      const response = await axiosInstance.get(`${domain}/countryStates?countryId=${countryid}`);
      commit('SET_CANTON', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadBankHolidays({ commit }, { countryStateId, year }) {
    const requestId = 'loadBankHolidays'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/bankHolidays`, {
        params: {
          countryStateId,
          year,
        },
      });
      commit('SET_BANKHOLIDAYS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async bankHolidays({ commit }, { object, successCallback }) {
    const requestId = 'bankHolidays'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/addBankHolidays`, object);
      commit('SET_STATUS', true);
      successCallback();
      Swal.fire({
        icon: 'success',
        title: 'Bank holiday added successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false })
  },
  async copyBankHolidays({ commit },
    { countryStateId, year, successCallback }) {
    const requestId = 'copyBankHolidays'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });

    try {
      await axiosInstance.post(`${domain}/copyBankHolidays?countryStateId=${countryStateId}&year=${year}`);
      commit('SET_STATUS', true);
      successCallback();
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editBankHolidays({ commit }, { bankHolidayId, object }) {
    const requestId = 'editBankHolidays'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/editBankHolidays/{id}?bankHolidayId=${bankHolidayId}`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Bank holiday edited successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editSaturdayWork({ commit }, { id, object, successCallback }) {
    const requestId = 'editSaturdayWork'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/editSaturdayWork?id=${id}`, object);
      commit('SET_STATUS', true);
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Saturday work edited successfully',
      //   toast: true,
      //   position: 'top-end',
      //   showConfirmButton: false,
      //   timer: 2500,
      // });
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async addSaturdayWork({ commit }, { object, successCallback }) {
    const requestId = 'addSaturdayWork'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/addSaturdayWork`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.Message,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4500,
      });
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async leaveRequest({ commit }, { object, successCallback }) {
    const requestId = 'leaveRequest'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/addVacationRequest`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.Message,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4500,
      });
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async addCoManagerToStores({ commit }, object) {
    const requestId = 'addCoManagerToStores'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain2}/addCoManagerToStores`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async getAlreadyRequestedVacation({ commit }, {
    employeeUserId, startDate, endDate,
  }) {
    const requestId = 'getAlreadyRequestedVacation'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/alreadyRequestedVacation`, {
        params: {
          employeeUserId,
          startDate,
          endDate,
        },
      })
      commit('SET_ALREADY_REQUESTED_VACATION', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadSaturdayWork({ commit }) {
    const requestId = 'loadSaturdayWork'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/saturdayWork`)
      commit('SET_SATURDAY_WORK', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async cancelVacation({ commit }, vacationRequestId) {
    const params = {
      vacationRequestId,
    };
    const requestId = 'cancelVacation'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/cancellVacationRequest`, null, { params });
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editVacationDays({ commit }, {
    employeeUserId, numberOfDays, year, successCallback,
  }) {
    const params = {
      employeeUserId,
      numberOfDays,
      year,
    };
    const requestId = 'editVacationDays'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/editVacationDays`, null, { params });
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback(); // Call the successCallback if it exists
  },
  async moveVacationDays({ commit }, {
    employeeUserId, currentYear, newYear, amountOfDays, successCallback,
  }) {
    const params = {
      employeeUserId,
      currentYear,
      newYear,
      amountOfDays,
    };
    const requestId = 'moveVacationDays'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/moveVacationDays`, null, { params });
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback(); // Call the successCallback if it exists
  },
  async payVacationDays({ commit }, {
    employeeUserId, numberOfDays, year, successCallback,
  }) {
    const params = {
      employeeUserId,
      numberOfDays,
      year,
    };
    const requestId = 'payVacationDays'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/payVacationDays`, null, { params });
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback(); // Call the successCallback if it exists
  },
  async loadVacationRequests({ commit }, { employeeId, year }) {
    const requestId = 'loadVacationRequests'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/vocationRequests`, {
        params: {
          employeeId,
          year,
        },
      });
      commit('SET_VACATION_REQUESTS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async remainingDaysOfEmployee({ commit }, { employeeUserId, year }) {
    const requestId = 'remainingDaysOfEmployee'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/remainingDaysOfEmployee`, {
        params: {
          employeeUserId,
          year,
        },
      });
      commit('SET_REMAINING_DAYS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
